export default {
  contactHeroTitle: "Kontaktieren Sie uns",
  contactHeroSubtitle: "Wir sind hier, um Ihnen bei der Navigation in der komplexen Welt der pharmazeutischen Entwicklung zu helfen. Ob Sie API-Herstellung, Formulierungsentwicklung oder regulatorische Unterstützung benötigen, unser Team ist bereit zu helfen.",
  contactGetInTouchTitle: "Kontakt aufnehmen",
  contactOurAddress: "Unsere Adresse",
  contactMainAddress: "67, Bazullah Road,<br />Partha Sarathy Puram,<br />T Nagar, Chennai – 600017<br />Tamil Nadu, Indien",
  contactOtherAddresses: "Weitere Adressen",
  contactAddressBangalore: "Phoenix Mall of Asia – Tower 2,<br />Level 6, Unit 602, Yelahanka Hobli,<br />Byatarayanapura, Bangalore – 560092,<br />Karnataka, Indien",
  contactAddressMumbai: "409, Bezzola Complex,<br />Sion Trombay Road,<br />Chembur, Mumbai - 400 071<br />Maharashtra, Indien.",
  contactAddressSwitzerland: "Bahnhof-Park 4,<br />Baar 6340,<br />Schweiz",
  contactEmail: "E-Mail",
  contactFormTitle: "Senden Sie uns eine Nachricht",
  contactFormNameLabel: "Vollständiger Name *",
  contactFormNamePlaceholder: "Geben Sie Ihren vollständigen Namen ein",
  contactFormEmailLabel: "E-Mail-Adresse *",
  contactFormEmailPlaceholder: "Geben Sie Ihre E-Mail-Adresse ein",
  contactFormPhoneLabel: "Telefonnummer",
  contactFormPhonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
  contactFormCompanyLabel: "Unternehmen",
  contactFormCompanyPlaceholder: "Geben Sie Ihren Firmennamen ein",
  contactFormMessageLabel: "Nachricht *",
  contactFormMessagePlaceholder: "Erzählen Sie uns von Ihrem Projekt oder Ihrer Anfrage...",
  contactFormCharacters: "Zeichen",
  contactFormSubmitButton: "Kontakt aufnehmen",
  contactFormSubmitting: "Wird gesendet...",
  contactFormRecaptchaRequired: "Bitte vervollständigen Sie das reCAPTCHA",
  contactFormSuccess: "Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet. Wir werden Ihnen innerhalb von 24 Stunden antworten.",
  contactFormError: "Entschuldigung, beim Senden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.",
};

